export default {
    closeButton: {
        textAlign: "end",
    },
    excludedListHeader: {
        mt: 2,
        p: 0,
        alignItems: "flex-end",
        "& div": {
            textAlign: "center",
        },
    },
    excludedList: {
        mt: 2,
        height: "40vh",
        overflow: "scroll",
        alignContent: "start",
    },
    listContainer: {
        width: "100%",
        maxHeight: "40vh",
        overflow: "auto",
    },
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        borderRadius: 1,
        p: 1,
        width: "90%",
    },
    modalMessage: {
        whiteSpace: "break-spaces",
        textAlign: "justify",
        m: 1,
    },
    signatureContainer: {
        " & canvas ": {
            border: "1px solid black",
            borderRadius: "15px",
        },
        "& div button": {
            margin: 2,
        },
    },
    paperHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
    },
    textArea: {
        "& textarea": {
            padding: 2,
            borderRadius: "8px",
            border: "1px solid ",
        },
    },
    auditSubmissionContainer: {
        padding: 2,
    },
    signatureImage: {
        width: "200px",
        height: "150px",
        justifySelf: "center",
    },
    uploadMessageContainer: {
        justifyContent: "center",
        position: "absolute",
        width: "100%",
        display: "grid",
        top: "40%",
    },
    progressBar: { marginTop: "10px", width: "100%" },
};
